import React from 'react'
import { withRouter } from 'react-router'

import { RequestContextProps } from 'src/lib/js/context'

import {
  isToastLocalRequest,
  isToastOrderRequest,
  isToastAppOrderRequest
} from 'public/js/siteUtilities'

import SitesRoutes from './SitesRoutes'
import ToastLocalRoutes from './ToastLocalRoutes'
import ToastOrderRoutes from './ToastOrderRoutes'
import ToastAppOrderRoutes from './ToastAppOrderRoutes'

export const Routes = ({ staticContext }: RequestContextProps) => {
  // Check for /r/:slug/order pattern on toast.app and book.toasttab.com
  if (isToastAppOrderRequest(staticContext)) {
    return <ToastAppOrderRoutes staticContext={staticContext} />
  }

  if (isToastLocalRequest(staticContext)) {
    return <ToastLocalRoutes />
  }

  if (isToastOrderRequest(staticContext)) {
    return <ToastOrderRoutes staticContext={staticContext} />
  }

  return <SitesRoutes staticContext={staticContext} />
}

export default withRouter<
  RequestContextProps,
  React.ComponentType<RequestContextProps>
>(Routes)
